// extracted by mini-css-extract-plugin
export default {"cover_letter_container":"styles_cover_letter_container__Q9tlU","cover_letter_sub_container":"styles_cover_letter_sub_container__mYS7f"};